import React, { useState, useRef } from 'react';
import {
  Paper,
  Typography,
  Menu,
  MenuItem,
  IconButton,
  useTheme
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

// Option type for each menu item
interface OptionItem {
  name: string;
  click?: (cameraName: string) => void;
}

// Props for CameraButton component
interface cButtonProps {
  name: string;
  options?: OptionItem[];
  handleClick: (name: string) => void; // Parent click callback when no options
  onSelect?: (cameraName: string, option: OptionItem) => void; // Parent callback for menu select
  isSelected?: boolean; // for styling the selected button
}

const CameraButton: React.FC<cButtonProps> = ({
  name,
  options = [],
  handleClick,
  onSelect,
  isSelected = false
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuWidth, setMenuWidth] = useState<number | null>(null);
  const paperRef = useRef<HTMLDivElement>(null);
  const theme = useTheme();


  

  // Opens the dropdown menu
  const handleOpenMenu = () => {
    if (paperRef.current) {
      setAnchorEl(paperRef.current);
      setMenuWidth(paperRef.current.offsetWidth);
    }
  };

  // Closes the dropdown menu
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  // Handles the Paper onClick logic
  const handlePaperClick = () => {
    
    if (options.length === 0) {
      // If there are no options, call the parent's handleClick prop
      handleClick(name);
    } else {
      // If options exist, open the dropdown menu
      handleOpenMenu();
    }
  };

  console.log('Options length:', options);
  

  return (
    <div className="relative flex items-center gap-2">
      <Paper
        ref={paperRef}
        elevation={1}
        className={`px-[8px] rounded-md cursor-pointer flex items-center justify-between w-full transition-all duration-300`}
        style={{
          boxShadow: isSelected
            ? '4px 4px 16px 0px #1E1E1E1A'
            : '4px 4px 16px 0px rgba(0, 0, 0, 0.05)',
          background: isSelected ? '#EEEDFC' : '',
          borderRadius: '8px',
          color: isSelected ? theme.palette.primary.main : 'inherit'
        }}
        onClick={handlePaperClick} // <<<< CLICK HANDLER HERE
      >
        <Typography
          variant="button"
          fontWeight={400}
          className="py-1 truncate px-2"
        >
          {name}
        </Typography>

        {options.length > 0 && (
          <IconButton
            onClick={(e) => {
              e.stopPropagation(); // prevent triggering the paper click
              handleOpenMenu();
            }}
            size="small"
            className="ml-2"
          >
            <KeyboardArrowDownIcon fontSize="small" />
          </IconButton>
        )}
      </Paper>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        PaperProps={{
          className: 'shadow-md rounded-md px-0 py-1',
          style: {
            minWidth: menuWidth || undefined
          }
        }}
      >
        {options.map((item, index) => (
          <MenuItem
            key={index}
            onClick={() => {
              item.click && item.click(name);
              onSelect && onSelect(name, item);
              handleCloseMenu();
            }}
            className="hover:bg-gray-100 rounded-md w-full"
            style={{ paddingLeft: '16px', paddingRight: '16px' }}
          >
            <Typography variant="body2" fontWeight={600} className="w-full">
              {item.name}
            </Typography>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};

export default CameraButton;
